var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", { attrs: { title: _vm.headerText } }, [
        _vm._v(" " + _vm._s(_vm.headerText) + " "),
      ]),
      _vm.files.length > 0
        ? _c(
            "v-expansion-panel-content",
            [
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.files, function (file, i) {
                    return _c("FileList", {
                      key: i,
                      attrs: { file: file },
                      on: {
                        "changed-files": function ($event) {
                          return _vm.$emit("changed-files")
                        },
                      },
                    })
                  }),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        title: `${
                          _vm.selectAllText
                        } all ${_vm.headerText.toLowerCase()}`,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("changed-files")
                        },
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("toggle-all")
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-action",
                        [
                          _c("v-checkbox", {
                            attrs: {
                              color: "blue",
                              indeterminate: _vm.isIndeterminate,
                              "input-value": _vm.allSelectedValue,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-format-list-bulleted"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.selectAllText) +
                                  " all " +
                                  _vm._s(_vm.headerText.toLowerCase())
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "pt-5 pb-5", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: { small: "", disabled: !_vm.anyItemSelected },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("remove-selected")
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Remove selected " + _vm._s(_vm.headerText) + " "
                            ),
                          ]),
                          _c("v-icon", { attrs: { right: "" } }, [
                            _vm._v("mdi-text-box-remove-outline"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.enableCompareView ? _c("v-divider") : _vm._e(),
                  _vm.enableCompareView
                    ? _c(
                        "v-list-item",
                        {
                          attrs: {
                            title: `Comparison View: ${
                              _vm.compareViewActive ? "enabled" : "disabled"
                            }`,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("toggle-compare-view")
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-action",
                            [
                              _c("v-switch", {
                                attrs: {
                                  color: "blue",
                                  "input-value": _vm.compareViewActive,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("Comparison View"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _c("v-expansion-panel-content", [
            _vm._v(
              " No " +
                _vm._s(_vm.headerText.toLowerCase()) +
                " are currently loaded. "
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }